import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=f23cf6dc&scoped=true"
import script from "./Tree.vue?vue&type=script&lang=ts"
export * from "./Tree.vue?vue&type=script&lang=ts"
import style0 from "./Tree.vue?vue&type=style&index=0&id=f23cf6dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23cf6dc",
  null
  
)

export default component.exports